<template>
  <section v-bind:id="id" class="section">
    <h2>
      <i class="material-icons left">{{ iconName }}</i>
      {{ title }}
    </h2>

    <p v-if="!hasDadosEscolares" class="flow-text center">
      Nenhuma formação foi encontrada.
    </p>
    <div v-else>
      <BaseProgressBar v-if="loading" v-bind="progressBar">
        Carregando dados auxiliares...
      </BaseProgressBar>
      <BaseCollection v-else>
        <template v-slot:items>
          <li
            v-for="(item, index) in dadoEscolarCollection.items"
            v-bind:key="index"
            class="collection-item"
          >
            <BaseDadoEscolar v-bind="item" />
          </li>
        </template>
      </BaseCollection>
    </div>
  </section>
</template>

<script>
import { API_URL } from "../../constants";
import BaseDadoEscolar from "./BaseDadoEscolar.vue";

const sort = function (a, b) {
  const { dataConclusaoA } = a.value;
  const { dataConclusaoB } = b.value;

  if (dataConclusaoA && dataConclusaoB) {
    return dataConclusaoA < dataConclusaoB ? -1 : 1;
  } else {
    // Se alguma das datas for nula, coloca ela no topo da lista
    return -1;
  }
};

const getInstituicaoEnsino = function (vm, item) {
  const { value } = item;
  const { instituicaoEnsinoId, escolaridadeNome } = value;

  if (!instituicaoEnsinoId) {
    return Promise.resolve();
  }

  return vm.$http
    .get(`${API_URL}/core/instituicaoEnsino/${instituicaoEnsinoId}`)
    .then(response => {
      value.instituicaoEnsino = response.data;
      value.instituicaoEnsino.pais = null;

      return value.instituicaoEnsino;
    })
    .catch(error =>
      vm.$notification.pushError(
        `Houve um erro ao obter a instituição de ensino da escolaridade "${escolaridadeNome}": ${error.message}`
      )
    )
    .then(response => {
      const paisId = response ? response.paisId : null;

      if (!paisId) {
        return;
      }

      return vm.$http
        .get(`${API_URL}/core/pais/${paisId}`)
        .then(response => (value.instituicaoEnsino.pais = response.data))
        .catch(error =>
          vm.$notification.pushError(
            `Houve um erro ao obter o país da instituição de ensino "${value}": ${error.message}`
          )
        );
    });
};

export default {
  name: "DadosFormacao",
  components: {
    BaseDadoEscolar
  },
  inheritAttrs: false,
  props: {
    id: {
      type: String,
      required: true
    },

    title: String,
    iconName: String,

    dadosEscolares: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      loading: false,
      progressBar: {
        useContainer: false
      },
      dadoEscolarCollection: {
        items: this.dadosEscolares
          .map(item => ({
            ...this.buildElementProps(item.id),
            value: { ...item }
          }))
          .sort(sort)
      }
    };
  },
  computed: {
    hasDadosEscolares() {
      return !this.$utils.Lang.isEmpty(this.dadosEscolares);
    }
  },
  created() {
    this.loading = true;

    const promises = this.dadoEscolarCollection.items.map(item =>
      getInstituicaoEnsino(this, item)
    );

    Promise.all(promises).finally(() => (this.loading = false));
  },
  methods: {
    buildElementId(itemId, name) {
      return itemId
        ? `dadosformacao-${itemId}-${name}`
        : this.$utils.Object.uuid();
    },
    buildElementProps(itemId) {
      return {
        escolaridadeNome: {
          id: this.buildElementId(itemId, "escolaridadenome"),
          label: "Escolaridade",
          gridExpression: "col s12 m9"
        },
        dataConclusao: {
          id: this.buildElementId(itemId, "dataconclusao"),
          label: "Data de conclusão",
          gridExpression: "col s12 m3"
        },
        instituicaoEnsino: {
          id: this.buildElementId(itemId, "instituicaoensino"),
          label: "Instituição de ensino",
          gridExpression: "col s12"
        }
      };
    }
  }
};
</script>

<style scoped>
.row {
  margin-bottom: 0;
}
</style>
